export default __webpack_public_path__ + "static/media/3 Assistant Manager Desk.199b98d4.jpg";